module.exports = __webpack_public_path__ + "static/msp-d5f11ccecdb817b091a7596af32b704e.png";